module.exports = __webpack_public_path__ + "img/72.1.47248125.jpg";